import React, { useState } from 'react';
import { User, UserPlus } from 'lucide-react';

interface AvatarProps {
  src?: string;
  name?: string;
  isPending?: boolean;
  className?: string;
  iconSize?: number;
  color?: string;
}

const Avatar: React.FC<AvatarProps> = ({ src, name, isPending, className = "w-10 h-10", iconSize = 20, color }) => {
  const [hasError, setHasError] = useState(false);

  // If we have a source and no error yet, try to render the image
  if (src && src.trim() !== '' && !hasError) {
    return (
      <img 
        src={src} 
        alt={name || 'User'} 
        onError={() => setHasError(true)}
        className={`${className} rounded-full object-cover border border-slate-200 dark:border-white/10 shadow-sm`} 
      />
    );
  }

  // Fallback styling inspired by professional design systems (MUI/Tailwind UI)
  const baseClasses = `${className} rounded-full flex items-center justify-center border shadow-sm transition-all overflow-hidden shrink-0`;
  
  if (isPending) {
    return (
      <div className={`${baseClasses} bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-500/20 text-amber-600 dark:text-amber-400`} title="Pending Connection">
        <UserPlus size={iconSize} />
      </div>
    );
  }

  return (
    <div 
      className={`${baseClasses} ${!color ? 'bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-white/5 text-slate-400 dark:text-slate-500' : 'border-white/20 shadow-inner'}`}
      style={color ? { backgroundColor: color, color: '#ffffff' } : {}}
    >
      <User size={iconSize} className={color ? 'drop-shadow-md' : ''} />
    </div>
  );
};

export default Avatar;